module.exports = __webpack_public_path__ + "static/media/29ADMSPC32.dd2b415b.jpg";